import { render, staticRenderFns } from "./vehicleIncome.vue?vue&type=template&id=6c56033c&scoped=true"
import script from "./vehicleIncome.vue?vue&type=script&lang=js"
export * from "./vehicleIncome.vue?vue&type=script&lang=js"
import style0 from "./vehicleIncome.vue?vue&type=style&index=0&id=6c56033c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c56033c",
  null
  
)

export default component.exports